module.exports = __webpack_public_path__ + "img/akiMouseResize.7f66ab22.png";